import { Box } from '@mui/material';

// Renders a Material Symbols icon by API-provided name, with a default fallback
export const DocIcon = ({ name, size = 24, color, className = '' }) => (
  <Box
    component="span"
    className={`material-symbols-outlined select-none ${className}`}
    sx={{ fontSize: `${size}px`, color, lineHeight: 1 }}
    aria-hidden
  >
    {name || 'description'}
  </Box>
);
